// River 新服务器正式配置
// API、WebSocket 自动跟随当前访问域名，后续换域名无需重新改这里。

const VUE_APP_WS_URL =
  typeof window !== 'undefined'
    ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/websocket`
    : '';

const VUE_APP_BASEURL =
  typeof window !== 'undefined'
    ? window.location.origin + '/api'
    : '';

// 保留旧 River 的钱包登录模式
const JUST_WALLET = true;

export { VUE_APP_WS_URL, VUE_APP_BASEURL, JUST_WALLET };
